var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.582,
    height: 48.608,
    viewBox: "0 0 55.582 48.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_menu_1166835_000000",
    transform: "translate(-11.3 -16.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M64.076,51.563H14.033a2.733,2.733,0,0,1,0-5.466H64.149a2.733,2.733,0,1,1-.073,5.466Z",
    transform: "translate(0 -8.429)",
    fill: "#2c2b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M64.076,21.563H14.033a2.733,2.733,0,1,1,0-5.466H64.149a2.733,2.733,0,1,1-.073,5.466Z",
    fill: "#2c2b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M64.076,81.563H14.033a2.733,2.733,0,1,1,0-5.466H64.149a2.733,2.733,0,1,1-.073,5.466Z",
    transform: "translate(0 -16.858)",
    fill: "#2c2b34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBur);
export default __webpack_public_path__ + "static/media/bur.fe2c2d73878d3d09598e4927a2d78476.svg";
export { ForwardRef as ReactComponent };